import { Region } from "./region.model";
import { EmcSearchOutput } from "./emc-search.model";
import { SortType } from "./sortType.model";
import { DateType } from "../enums/date-type";
import { UserType } from "../enums/user-type";

export class Filter {
  pageInfo: PageInfo = new PageInfo(10, 1);
  filterParams: StaticFilter = new StaticFilter();
  dynamicFilters: DynamicFilter[] = [];
  searchObject: EmcSearchOutput = new EmcSearchOutput();
  utilityId: number = 0;
  substationTemplateId: number | null = null;

  constructor(utilityId?: number, substationTemplateId?: number) {
    this.utilityId = utilityId ?? 0;
    this.substationTemplateId = substationTemplateId ?? 0;
  }
}

export class FilterOption {
  attributeLabel: string;
  optionId: number;
  optionValue: string;
  constructor(attributeLabel: string, optionId: number, optionValue: string) {
    this.optionId = optionId;
    this.optionValue = optionValue;
    this.attributeLabel = attributeLabel;
  }
}

export class StaticFilter {
  search: string = '';
  filterBy: string = '';
  userType: UserType | null = null;
  sortBy: SortType = SortType.NEWEST;
  dateFrom: string | null = null;
  dateTo: string | null = null;
  dateType: DateType = DateType.LastUpdateTime;
  selectedRegion: Region | null = null;
  selectedAreas: number[] = [];
  status: number | null = null;
  statuses: number[] = [];
  type: number | null = null;
  reviewStatus: number | null = null;
  auditStatus: number | null = null;
  gisReviewStatus: number | null = null;
  gisUpdateStatus: number | null = null;
  selectedIds: number[] = [];
  selectedUsers: number[] = [];
  selectedTransmissionStations: number[] = [];

  // additional filter fields
  dateTypeString: string = 'Last Update Time';
  areaSearchText: string = '';
  regionSearchText: string = '';
  tsSearchText: string = '';
  selectedUserTypeString: string | null = null;
  searchUsersText: string = '';
  sortByName: string = 'Newest';
  selectedAreaModels: { id: number; name: string }[] = [];
  selectedTsModels: { id: number; name: string }[] = [];
  selectedUserModels: { id: number; name: string }[] = [];
}

export class DynamicFilter {
  attributeDefinitionId!: number;
  attributeLabel!: string;
  selectedOptions?: number[];
  from?: Date | null;
  to?: Date | null;

  // additional filter fields
  optionDefinitions: FilterOption[] = [];
}

export class PageInfo {
  pageSize: number;
  page: number;

  constructor(pageSize: number = 10, page: number = 1) {
    this.pageSize = pageSize;
    this.page = page;
  }
}